import { styled } from 'linaria/react';

export const GalleryGrid = styled.div`
  display: grid;
  grid-gap: 24px;
  grid-template-columns: repeat(2, 1fr);

  @media (--only-tablet) {
    grid-column-gap: unset;
    grid-template-columns: 1fr;
    margin-bottom: 48px;
  }

  @media (--only-mobile) {
    grid-column-gap: unset;
    grid-template-columns: 1fr;
    margin-bottom: 32px;
  }
`;

export const GalleryGridTwoCols = styled(GalleryGrid)`
  @media (--only-tablet) {
    grid-column-gap: 24px;
    grid-template-columns: repeat(2, 1fr);
  }

  @media (--only-mobile) {
    grid-row-gap: 16px;
  }
`;
